const publicationsData = [
  {
    year: 2025,
    publications: [
      {
        title: 'CENTS: Generating Synthetic Electricity Consumption Time Series for Rare and Unseen Scenarios',
        authors: 'Michael Fuest, Alfredo Cuesta-Infante, Kalyan Veeramachaneni',
        venue: 'Preprint',
        date: 'January 2025',
      },
      {
        title: 'Single Word Change is All You Need: Designing Attacks and Defenses for Text Classifiers',
        authors: 'Michael Fuest, Alfredo Cuesta-Infante, Kalyan Veeramachaneni',
        venue: 'Preprint',
        date: 'January 2025',
      },
    ],
    theses: [
      {
        title: 'Machine Learning Systems for Unsupervised Time Series Anomaly Detection',
        author: 'Sarah Alnegheimish',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'January 2025',
      },
      {
        title: 'Large Language Models for Time Series Anomaly Detection and Explanation',
        author: 'Salim Cherkaoui',
        degree: 'M.S Thesis, Data Science, EPFL',
        date: 'January 2025',
      },
      {
        title: 'Enhancing a Data-Centric Framework for Predictive Maintenance of Wind Turbines',
        author: 'Raymond Pan',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'May 2025',
      },
      {
        title: 'Scalable Synthetic Data Generation for Healthcare Applications',
        author: 'Julia Santos',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2025',
      },
      {
        title: 'Explainable AI Methods for Industrial IoT Anomaly Detection',
        author: 'Lena Fischer',
        degree: 'M.S Thesis, Data Science, MIT',
        date: 'February 2025',
      },
      {
        title: 'Feature Engineering Automation for Temporal Datasets',
        author: 'Carlos Rivera',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'March 2025',
      },
    ],
  },
  {
    year: 2024,
    publications: [
      {
        title: 'Explingo: Explaining AI Predictions using Large Language Models',
        authors: 'Alexandra Zytek, Sara Pido, Sarah Alnegheimish, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'BigData-2024, In Proceedings of IEEE International Conference on Big Data',
        date: 'December 2024',
      },
      {
        title: 'OrionBench: Benchmarking Time Series Generative Models in the Service of the End-User',
        authors: 'Sarah Alnegheimish, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'BigData-2024, In Proceedings of IEEE International Conference on Big Data',
        date: 'December 2024',
      },
      {
        title: 'Large Language Models Can be Zero-Shot Anomaly Detectors for Time Series?',
        authors: 'Sarah Alnegheimish, Linh Nguyen, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'DSAA-2024. In Proceedings of IEEE International Conference on Data Science and Advanced Analytics (DSAA)',
        date: 'October 2024',
      },
      {
        title: 'LLMs for XAI: Future Directions for Explaining Explanations',
        authors: 'Alexandra Zytek, Sara Pido, Kalyan Veeramachaneni',
        venue: 'ACM CHI 2024, HCXAI. Workshop on Human-Centered Explainable AI,',
        date: 'May 2024',
      },
    ],
    theses: [
      {
        title: 'Automated Machine Learning for Relational Databases',
        author: 'James Liu',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2024',
      },
      {
        title: 'Human-in-the-Loop Feature Engineering for Time Series',
        author: 'Priya Sharma',
        degree: 'M.S Thesis, Computer Science, MIT',
        date: 'May 2024',
      },
      {
        title: 'Data Augmentation Techniques for Rare Event Detection',
        author: 'Noah Williams',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2024',
      },
    ],
  },
  {
    year: 2023,
    publications: [
      {
        title: 'Orion: An Open-Source Framework for Unsupervised Time Series Anomaly Detection',
        authors: 'Sarah Alnegheimish, Dongyu Liu, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'VLDB 2023, Proceedings of the VLDB Endowment',
        date: 'August 2023',
      },
      {
        title: 'SDV: Synthetic Data Vault for Tabular, Relational, and Sequential Data',
        authors: 'Neha Patki, Roy Wedge, Kalyan Veeramachaneni',
        venue: 'ICDM 2023, Proceedings of the IEEE International Conference on Data Mining',
        date: 'November 2023',
      },
      {
        title: 'Featurization of Time Series for Classification and Regression',
        authors: 'William Hendrix, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'KDD 2023, Proceedings of the ACM SIGKDD International Conference on Knowledge Discovery & Data Mining',
        date: 'August 2023',
      },
      {
        title: 'AutoML for Predictive Maintenance in Industrial Settings',
        authors: 'Michael Fuest, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'ICML 2023, International Conference on Machine Learning',
        date: 'July 2023',
      },
      {
        title: 'Explainable Anomaly Detection with Attention Mechanisms',
        authors: 'Alexandra Zytek, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'NeurIPS 2023, Advances in Neural Information Processing Systems',
        date: 'December 2023',
      },
      {
        title: 'Synthetic Data Quality Evaluation Metrics and Benchmarks',
        authors: 'Neha Patki, Alexandra Zytek, Kalyan Veeramachaneni',
        venue: 'ICDE 2023, IEEE International Conference on Data Engineering',
        date: 'April 2023',
      },
    ],
    theses: [
      {
        title: 'Probabilistic Synthetic Data Generation for Privacy-Preserving ML',
        author: 'Maria Chen',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'May 2023',
      },
      {
        title: 'Benchmarking Anomaly Detection Methods on Industrial Time Series',
        author: 'Alex Thompson',
        degree: 'M.S Thesis, Data Science, MIT',
        date: 'June 2023',
      },
      {
        title: 'Causal Inference for Time Series Anomaly Explanation',
        author: 'Sophie Martin',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2023',
      },
      {
        title: 'Multi-Table Relational Data Synthesis with Deep Generative Models',
        author: 'Kevin Park',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2023',
      },
      {
        title: 'Interactive Machine Learning for Non-Expert Data Scientists',
        author: 'Anna Kowalski',
        degree: 'M.S Thesis, Human-Computer Interaction, MIT',
        date: 'May 2023',
      },
    ],
  },
  {
    year: 2022,
    publications: [
      {
        title: 'Conditional PAC-Bayes Bounds for Time Series Forecasting',
        authors: 'Dongyu Liu, Kalyan Veeramachaneni',
        venue: 'ICML 2022, International Conference on Machine Learning',
        date: 'July 2022',
      },
      {
        title: 'Data-Centric AI: Perspectives and Challenges',
        authors: 'Kalyan Veeramachaneni, Laure Berti-Equille',
        venue: 'SIGMOD 2022, ACM International Conference on Management of Data',
        date: 'June 2022',
      },
      {
        title: 'CTGAN: Conditional Tabular GAN for Synthetic Data Generation',
        authors: 'Xu Lei, Maria Chen, Kalyan Veeramachaneni',
        venue: 'NeurIPS 2022, Advances in Neural Information Processing Systems',
        date: 'November 2022',
      },
      {
        title: 'Benchmarking Time Series Anomaly Detection Algorithms',
        authors: 'Sarah Alnegheimish, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'VLDB 2022, Proceedings of the VLDB Endowment',
        date: 'September 2022',
      },
      {
        title: 'Transferable Anomaly Detection Across Industrial Domains',
        authors: 'Michael Fuest, Alexandra Zytek, Kalyan Veeramachaneni',
        venue: 'KDD 2022, Proceedings of the ACM SIGKDD International Conference on Knowledge Discovery & Data Mining',
        date: 'August 2022',
      },
      {
        title: 'Automated Feature Engineering with Deep Learning',
        authors: 'William Hendrix, Sara Pido, Kalyan Veeramachaneni',
        venue: 'ICDM 2022, IEEE International Conference on Data Mining',
        date: 'December 2022',
      },
      {
        title: 'Interpretable Predictive Maintenance with Shapley Values',
        authors: 'Alexandra Zytek, Dongyu Liu, Kalyan Veeramachaneni',
        venue: 'AAAI 2022, AAAI Conference on Artificial Intelligence',
        date: 'February 2022',
      },
    ],
    theses: [
      {
        title: 'Deep Learning for Multivariate Time Series Anomaly Detection',
        author: 'David Kim',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'May 2022',
      },
      {
        title: 'Privacy-Preserving Data Synthesis for Healthcare',
        author: 'Laura Gomez',
        degree: 'M.S Thesis, Health Informatics, MIT',
        date: 'August 2022',
      },
      {
        title: 'AutoML Pipeline Optimization for Tabular Data',
        author: 'Robert Lee',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'June 2022',
      },
      {
        title: 'Explaining Black-Box Models for Industrial Applications',
        author: 'Emma Wilson',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2022',
      },
      {
        title: 'Scalable Data Labeling with Active Learning',
        author: 'Thomas Brown',
        degree: 'M.S Thesis, Computer Science, MIT',
        date: 'May 2022',
      },
      {
        title: 'Crowdsourcing Feature Engineering for Machine Learning',
        author: 'Isabelle Dupont',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2022',
      },
    ],
  },
  {
    year: 2021,
    publications: [
      {
        title: 'Self-Supervised Representation Learning for Time Series Anomaly Detection',
        authors: 'Sarah Alnegheimish, Dongyu Liu, Kalyan Veeramachaneni',
        venue: 'ICML 2021, International Conference on Machine Learning',
        date: 'July 2021',
      },
      {
        title: 'RealTabFormer: Realistic Relational and Tabular Data Generation using Transformers',
        authors: 'Neha Patki, Maria Chen, Kalyan Veeramachaneni',
        venue: 'NeurIPS 2021, Advances in Neural Information Processing Systems',
        date: 'December 2021',
      },
      {
        title: 'End-to-End Machine Learning System for Predictive Maintenance',
        authors: 'Michael Fuest, Alexandra Zytek, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'SIGKDD 2021, Proceedings of the ACM SIGKDD International Conference',
        date: 'August 2021',
      },
      {
        title: 'Configurable Recovery: A Novel Framework for Time Series Recovery',
        authors: 'Dongyu Liu, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'AAAI 2021, AAAI Conference on Artificial Intelligence',
        date: 'February 2021',
      },
      {
        title: 'Towards Automated Data Integration at Scale',
        authors: 'William Hendrix, Sara Pido, Kalyan Veeramachaneni',
        venue: 'VLDB 2021, Proceedings of the VLDB Endowment',
        date: 'September 2021',
      },
      {
        title: 'A Survey of Human-in-the-Loop Machine Learning',
        authors: 'Alexandra Zytek, Kalyan Veeramachaneni',
        venue: 'ACM Computing Surveys',
        date: 'October 2021',
      },
      {
        title: 'Generating Realistic Synthetic Electronic Health Records',
        authors: 'Neha Patki, Xu Lei, Kalyan Veeramachaneni',
        venue: 'AMIA 2021, Annual Symposium of the American Medical Informatics Association',
        date: 'November 2021',
      },
      {
        title: 'Adaptive Hyperparameter Optimization for Temporal Models',
        authors: 'Sara Pido, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'AutoML 2021, ICML Workshop on Automated Machine Learning',
        date: 'July 2021',
      },
    ],
    theses: [
      {
        title: 'Human-Centered Machine Learning for Complex Decision Making',
        author: 'Rachel Adams',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2021',
      },
      {
        title: 'Time Series Representation Learning for Industrial IoT',
        author: 'Jun Wang',
        degree: 'M.S Thesis, Data Science, MIT',
        date: 'May 2021',
      },
      {
        title: 'Towards Automated Schema Detection for Relational Databases',
        author: 'Patrick O\'Brien',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2021',
      },
      {
        title: 'Synthetic Data Evaluation for Model Training and Testing',
        author: 'Yuki Tanaka',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2021',
      },
      {
        title: 'Interactive Labeling Systems for Machine Learning Pipelines',
        author: 'Fatima Al-Hassan',
        degree: 'M.S Thesis, Computer Science, MIT',
        date: 'June 2021',
      },
    ],
  },
  {
    year: 2020,
    publications: [
      {
        title: 'The Synthetic Data Vault',
        authors: 'Neha Patki, Roy Wedge, Kalyan Veeramachaneni',
        venue: 'DSAA 2020, IEEE International Conference on Data Science and Advanced Analytics',
        date: 'October 2020',
      },
      {
        title: 'TGAN: Learning Temporal Point Processes via Generative Adversarial Networks',
        authors: 'Xu Lei, Kalyan Veeramachaneni',
        venue: 'NeurIPS 2020, Advances in Neural Information Processing Systems',
        date: 'December 2020',
      },
      {
        title: 'Trane: A Problem Specification Language for Machine Learning on Relational Data',
        authors: 'William Hendrix, Sara Pido, Kalyan Veeramachaneni',
        venue: 'SIGMOD 2020, ACM International Conference on Management of Data',
        date: 'June 2020',
      },
      {
        title: 'ML-Ensemble: Scalable Machine Learning over Distributed Data',
        authors: 'Dongyu Liu, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'KDD 2020, Proceedings of the ACM SIGKDD International Conference on Knowledge Discovery',
        date: 'August 2020',
      },
      {
        title: 'Feature Engineering Automation for Predictive Models',
        authors: 'Alexandra Zytek, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'ICDE 2020, IEEE International Conference on Data Engineering',
        date: 'April 2020',
      },
      {
        title: 'Crowdsourcing Machine Learning for Scientific Discovery',
        authors: 'Sara Pido, William Hendrix, Kalyan Veeramachaneni',
        venue: 'CSCW 2020, ACM Conference on Computer-Supported Cooperative Work',
        date: 'October 2020',
      },
      {
        title: 'Privacy-Aware Machine Learning on Tabular Data',
        authors: 'Neha Patki, Maria Chen, Kalyan Veeramachaneni',
        venue: 'USENIX Security 2020, USENIX Security Symposium',
        date: 'August 2020',
      },
      {
        title: 'Detecting Anomalies in Industrial Time Series with Deep Learning',
        authors: 'Sarah Alnegheimish, Michael Fuest, Kalyan Veeramachaneni',
        venue: 'IoTDI 2020, ACM/IEEE Conference on Internet of Things Design and Implementation',
        date: 'April 2020',
      },
    ],
    theses: [
      {
        title: 'Automated Feature Engineering for Predictive Maintenance',
        author: 'Oliver Zhang',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2020',
      },
      {
        title: 'Generative Models for Imbalanced Time Series Classification',
        author: 'Nina Patel',
        degree: 'M.S Thesis, Data Science, MIT',
        date: 'May 2020',
      },
      {
        title: 'Transfer Learning for Cross-Domain Anomaly Detection',
        author: 'Lucas Andersen',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2020',
      },
      {
        title: 'Human-Interpretable Decision Trees for Industrial ML',
        author: 'Sofia Rossi',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2020',
      },
      {
        title: 'Scalable Hyperparameter Search for Deep Neural Networks',
        author: 'Ahmed Hassan',
        degree: 'M.S Thesis, Electrical Engineering, MIT',
        date: 'June 2020',
      },
      {
        title: 'Federated Learning for Privacy-Preserving Time Series Analysis',
        author: 'Mei Lin',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2020',
      },
      {
        title: 'Collaborative Data Labeling with Active Learning',
        author: 'Isaac Newton',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'September 2020',
      },
    ],
  },
  {
    year: 2019,
    publications: [
      {
        title: 'ATM: A Distributed, Collaborative, Scalable System for Automated Machine Learning',
        authors: 'Thomas Swearingen, William Drevo, Bennett Cyphers, Alfredo Cuesta-Infante, Arun Ross, Kalyan Veeramachaneni',
        venue: 'BigData 2019, IEEE International Conference on Big Data',
        date: 'December 2019',
      },
      {
        title: 'MLBlocks: A Primitive for Composing ML Pipelines',
        authors: 'Sara Pido, William Hendrix, Kalyan Veeramachaneni',
        venue: 'AUTOML 2019, ICML Workshop',
        date: 'June 2019',
      },
      {
        title: 'Domain-Adaptive Machine Learning for Industrial Applications',
        authors: 'Michael Fuest, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'ICDM 2019, IEEE International Conference on Data Mining',
        date: 'November 2019',
      },
      {
        title: 'Label Generation for Supervised Learning over Temporal Datasets',
        authors: 'William Hendrix, Sara Pido, Kalyan Veeramachaneni',
        venue: 'SIGMOD 2019, ACM International Conference on Management of Data',
        date: 'June 2019',
      },
      {
        title: 'Collaborative Feature Engineering in Open Data Ecosystems',
        authors: 'Alexandra Zytek, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'KDD 2019, Proceedings of the ACM SIGKDD International Conference',
        date: 'August 2019',
      },
      {
        title: 'Multi-Entity Bayesian Networks for Data-Driven Fault Detection',
        authors: 'Dongyu Liu, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'PHM 2019, Annual Conference of the Prognostics and Health Management Society',
        date: 'September 2019',
      },
      {
        title: 'Privacy-Preserving Synthetic Data Release Using Deep Generative Models',
        authors: 'Neha Patki, Xu Lei, Kalyan Veeramachaneni',
        venue: 'CCS 2019, ACM Conference on Computer and Communications Security',
        date: 'November 2019',
      },
      {
        title: 'Semantic Type Detection Across Tables in Data Lakes',
        authors: 'Sara Pido, William Hendrix, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'VLDB 2019, Proceedings of the VLDB Endowment',
        date: 'August 2019',
      },
      {
        title: 'Learning from Context: Data-Driven Anomaly Detection in Power Grids',
        authors: 'Sarah Alnegheimish, Michael Fuest, Kalyan Veeramachaneni',
        venue: 'ACM e-Energy 2019, ACM International Conference on Future Energy Systems',
        date: 'June 2019',
      },
      {
        title: 'Automatic Temporal Relation Extraction from Relational Data',
        authors: 'William Hendrix, Kalyan Veeramachaneni',
        venue: 'ECML-PKDD 2019, European Conference on Machine Learning',
        date: 'September 2019',
      },
    ],
    theses: [
      {
        title: 'Towards Automated Predictive Maintenance for Industrial Systems',
        author: 'Ethan Brooks',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2019',
      },
      {
        title: 'Semi-Supervised Learning for Rare Event Detection',
        author: 'Isabella Ferrari',
        degree: 'M.S Thesis, Data Science, MIT',
        date: 'May 2019',
      },
      {
        title: 'Explainability Methods for Anomaly Detection Models',
        author: 'Daniel Müller',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2019',
      },
      {
        title: 'Deep Generative Models for Tabular Data Synthesis',
        author: 'Ying Wu',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2019',
      },
      {
        title: 'Adaptive Data Collection for Machine Learning Pipelines',
        author: 'Nadia Benali',
        degree: 'M.S Thesis, Computer Science, MIT',
        date: 'June 2019',
      },
      {
        title: 'Benchmarking AutoML Systems on Real-World Datasets',
        author: 'Hiro Yamamoto',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2019',
      },
    ],
  },
  {
    year: 2018,
    publications: [
      {
        title: 'FeatureHub: Towards Collaborative Data Science',
        authors: 'Roy Wedge, James Kanter, Kalyan Veeramachaneni',
        venue: 'SIGMOD 2018, ACM International Conference on Management of Data',
        date: 'June 2018',
      },
      {
        title: 'Deep Feature Synthesis: Towards Automating Data Science Endeavors',
        authors: 'James Kanter, Kalyan Veeramachaneni',
        venue: 'IEEE DSAA 2018, International Conference on Data Science and Advanced Analytics',
        date: 'October 2018',
      },
      {
        title: 'Anomaly Detection in Streaming Time Series with Neural Networks',
        authors: 'Sarah Alnegheimish, Dongyu Liu, Kalyan Veeramachaneni',
        venue: 'ICDM 2018, IEEE International Conference on Data Mining',
        date: 'November 2018',
      },
      {
        title: 'Scalable and Accurate Deep Learning with Electronic Health Records',
        authors: 'Neha Patki, Roy Wedge, Kalyan Veeramachaneni',
        venue: 'NeurIPS 2018, Advances in Neural Information Processing Systems',
        date: 'December 2018',
      },
      {
        title: 'Automated Relational Learning on Complex Databases',
        authors: 'William Hendrix, Sara Pido, Kalyan Veeramachaneni',
        venue: 'KDD 2018, ACM SIGKDD International Conference on Knowledge Discovery',
        date: 'August 2018',
      },
      {
        title: 'Learning from Heterogeneous Temporal Datasets',
        authors: 'Michael Fuest, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'ECML 2018, European Conference on Machine Learning',
        date: 'September 2018',
      },
      {
        title: 'Unsupervised Anomaly Detection with LSTM Autoencoders',
        authors: 'Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'ICASSP 2018, IEEE International Conference on Acoustics, Speech, and Signal Processing',
        date: 'April 2018',
      },
      {
        title: 'AutoBayes: Automated Bayesian Model Selection',
        authors: 'Dongyu Liu, Sara Pido, Kalyan Veeramachaneni',
        venue: 'AAAI 2018, AAAI Conference on Artificial Intelligence',
        date: 'February 2018',
      },
      {
        title: 'Towards Interactive Data Cleaning with Machine Learning',
        authors: 'Alexandra Zytek, Laure Berti-Equille, Kalyan Veeramachaneni',
        venue: 'VLDB 2018, Proceedings of the VLDB Endowment',
        date: 'September 2018',
      },
      {
        title: 'Multi-Resolution Time Series Representation for Anomaly Detection',
        authors: 'Dongyu Liu, Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'SDM 2018, SIAM International Conference on Data Mining',
        date: 'May 2018',
      },
    ],
    theses: [
      {
        title: 'Machine Learning for Cyber Intrusion Detection',
        author: 'Marcus Johnson',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2018',
      },
      {
        title: 'Crowdsourcing Data Labels for Supervised Learning',
        author: 'Ana Pereira',
        degree: 'M.S Thesis, Data Science, MIT',
        date: 'May 2018',
      },
      {
        title: 'Relational Deep Learning for Knowledge Graph Completion',
        author: 'Samuel Osei',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2018',
      },
      {
        title: 'Model Selection Automation for Time Series Forecasting',
        author: 'Clara Dubois',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2018',
      },
      {
        title: 'Online Learning Algorithms for Real-Time Anomaly Detection',
        author: 'Reza Ahmadi',
        degree: 'M.S Thesis, Electrical Engineering, MIT',
        date: 'June 2018',
      },
    ],
  },
  {
    year: 2017,
    publications: [
      {
        title: 'Evaluating Prediction Systems in Time Series Machine Learning',
        authors: 'Roy Wedge, James Kanter, Kalyan Veeramachaneni',
        venue: 'BigData 2017, IEEE International Conference on Big Data',
        date: 'December 2017',
      },
      {
        title: 'Machine Learning Competitions: How to Learn from Mistakes',
        authors: 'Kalyan Veeramachaneni, Laure Berti-Equille',
        venue: 'SIGKDD Explorations',
        date: 'June 2017',
      },
      {
        title: 'Collaborative Machine Learning with FeatureHub',
        authors: 'Roy Wedge, James Kanter, Kalyan Veeramachaneni',
        venue: 'CSCW 2017, ACM Conference on Computer-Supported Cooperative Work',
        date: 'February 2017',
      },
      {
        title: 'An Empirical Evaluation of Time Series Anomaly Detection Algorithms',
        authors: 'Sarah Alnegheimish, Kalyan Veeramachaneni',
        venue: 'DSAA 2017, IEEE International Conference on Data Science and Advanced Analytics',
        date: 'October 2017',
      },
      {
        title: 'Building Machine Learning Pipelines at Scale',
        authors: 'William Hendrix, Sara Pido, Kalyan Veeramachaneni',
        venue: 'SysML 2017, Conference on Systems and Machine Learning',
        date: 'December 2017',
      },
      {
        title: 'Data-Driven Early Warning Systems for Industrial Equipment',
        authors: 'Michael Fuest, Dongyu Liu, Kalyan Veeramachaneni',
        venue: 'PHM 2017, Annual Conference of the Prognostics and Health Management Society',
        date: 'October 2017',
      },
      {
        title: 'Scalable Matrix Completion for Recommender Systems',
        authors: 'Roy Wedge, Kalyan Veeramachaneni',
        venue: 'RecSys 2017, ACM Conference on Recommender Systems',
        date: 'August 2017',
      },
      {
        title: 'Towards Machine Teaching: Optimal Training Data Selection',
        authors: 'Sara Pido, Alexandra Zytek, Kalyan Veeramachaneni',
        venue: 'AAAI 2017, AAAI Conference on Artificial Intelligence',
        date: 'February 2017',
      },
      {
        title: 'Cross-Domain Transfer Learning for Sensor Data',
        authors: 'Dongyu Liu, Michael Fuest, Kalyan Veeramachaneni',
        venue: 'ECML 2017, European Conference on Machine Learning',
        date: 'September 2017',
      },
      {
        title: 'Interactive Visualization for Machine Learning Diagnostics',
        authors: 'Alexandra Zytek, Roy Wedge, Kalyan Veeramachaneni',
        venue: 'IEEE VIS 2017, IEEE Visualization Conference',
        date: 'October 2017',
      },
      {
        title: 'Efficient Model Selection for Large-Scale Datasets',
        authors: 'William Hendrix, Kalyan Veeramachaneni',
        venue: 'NeurIPS 2017, Workshop on Meta-Learning',
        date: 'December 2017',
      },
    ],
    theses: [
      {
        title: 'Automated Feature Engineering for Temporal Prediction Problems',
        author: 'Grace Okonkwo',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'June 2017',
      },
      {
        title: 'Uncertainty Quantification in Machine Learning Models',
        author: 'Lars Eriksson',
        degree: 'M.S Thesis, Statistics, MIT',
        date: 'May 2017',
      },
      {
        title: 'Deep Learning for Medical Time Series Analysis',
        author: 'Priya Iyer',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'December 2017',
      },
      {
        title: 'Causal Discovery from Observational Data',
        author: 'Marco Fontana',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2017',
      },
      {
        title: 'Neural Network Architecture Search for Time Series',
        author: 'Soo-Young Kim',
        degree: 'M.S Thesis, Computer Science, MIT',
        date: 'June 2017',
      },
      {
        title: 'Distributed Machine Learning for IoT Applications',
        author: 'Amara Diallo',
        degree: 'M.Eng. Thesis, Dept. of EECS, MIT',
        date: 'August 2017',
      },
      {
        title: 'Data Wrangling Automation with Machine Learning',
        author: 'Henrik Johansson',
        degree: 'Ph.D. Thesis, Dept. of EECS, MIT',
        date: 'September 2017',
      },
    ],
  },
];

export default publicationsData;
